<div class="please-wait-component">
  <div class="popsy-loading-animation">
    <div class="animation">
      <div class="shapes"></div>
    </div>
  </div>
  <div class="label" *ngIf="message">{{ message }}</div>
</div>
